export const useCheckoutUrl = () => {
    const { urlSegment } = useLanguage();

    return computed(() => `/${urlSegment.value}/shop/checkout`);
};
